export const InkleCoin = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="34"
    height="36"
    viewBox="0 0 34 36"
    fill="none"
  >
    <path
      d="M12.6684 3.09318L15.3247 2.55717L21.3299 32.9061L18.6736 33.4421C11.6773 34.8539 4.66086 29.2044 3.00261 20.824C1.34436 12.4436 5.67209 4.50497 12.6684 3.09318Z"
      fill="#DB6402"
    />
    <g style={{ mixBlendMode: "multiply" }}>
      <path
        d="M21.1679 32.0847L21.3308 32.9079L18.6745 33.4439C15.7024 34.0436 12.7276 33.3653 10.1602 31.7487L20.7035 29.7425L21.167 32.0849L21.1679 32.0847Z"
        fill="#DBA97F"
      />
    </g>
    <g style={{ mixBlendMode: "soft-light" }}>
      <path
        d="M11.7667 14.0608L2.71167 15.797C2.89292 13.5734 3.48907 11.4838 4.42924 9.65727L10.7152 8.45221L11.7667 14.0608Z"
        fill="white"
      />
    </g>
    <g style={{ mixBlendMode: "soft-light" }}>
      <path
        d="M10.5049 7.38817L5.14893 8.41568C5.36694 8.07868 5.59737 7.75386 5.84127 7.44195L10.3534 6.57646L10.5058 7.388L10.5049 7.38817Z"
        fill="white"
      />
    </g>
    <path
      d="M21.3309 32.9054C28.3274 31.4936 32.6549 23.5552 30.9966 15.1746C29.3384 6.79396 22.3222 1.14463 15.3256 2.55647C8.32907 3.9683 4.00154 11.9067 5.65984 20.2873C7.31813 28.6679 14.3343 34.3173 21.3309 32.9054Z"
      fill="#FEE475"
    />
    <path
      d="M21.2329 32.4079C28 31.0424 32.1857 23.3646 30.5818 15.2591C28.978 7.15361 22.1919 1.68978 15.4248 3.05531C8.65771 4.42085 4.47206 12.0986 6.07591 20.2041C7.67977 28.3097 14.4658 33.7735 21.2329 32.4079Z"
      fill="#FED425"
    />
    <g style={{ mixBlendMode: "soft-light" }}>
      <path
        d="M26.9163 29.2564L5.79788 15.2777C5.98648 13.0774 6.59399 11.013 7.5485 9.22218L30.0338 24.1054C29.3467 26.0939 28.2831 27.8572 26.9163 29.2564Z"
        fill="white"
      />
    </g>
    <g style={{ mixBlendMode: "soft-light" }}>
      <path
        d="M7.25781 23.9521L20.2532 32.5542C14.9284 33.1189 9.74934 29.5704 7.25781 23.9521Z"
        fill="white"
      />
    </g>
    <g style={{ mixBlendMode: "soft-light" }}>
      <path
        d="M29.1783 11.0326L16.8467 2.87061C18.1159 2.78992 19.3729 2.94135 20.5828 3.29609L26.8146 7.42116C27.7335 8.47944 28.5339 9.69296 29.1785 11.0335L29.1783 11.0326Z"
        fill="white"
      />
    </g>
    <g style={{ mixBlendMode: "soft-light" }}>
      <path
        d="M30.4574 22.6625L8.28707 7.98758C8.46641 7.72176 8.65695 7.46654 8.85308 7.21662L30.6655 21.6551C30.6055 21.9951 30.5365 22.3314 30.4565 22.6626L30.4574 22.6625Z"
        fill="white"
      />
    </g>
    <g style={{ mixBlendMode: "soft-light" }}>
      <path
        d="M15.4353 3.11098C8.51595 4.50723 4.21115 12.286 5.71986 20.5634C5.69976 20.471 5.67721 20.38 5.65886 20.2873C4.00148 11.9067 8.32835 3.96825 15.3255 2.55629C22.3227 1.14433 29.3383 6.794 30.9966 15.1744C31.0149 15.2672 31.0287 15.3599 31.0453 15.453C29.2891 7.22554 22.3546 1.71473 15.4353 3.11098Z"
        fill="white"
      />
    </g>
    <g style={{ mixBlendMode: "soft-light" }}>
      <path
        d="M20.192 28.6373C25.0052 27.6661 27.9822 22.2049 26.8413 16.4394C25.7005 10.674 20.8739 6.78749 16.0607 7.75874C11.2475 8.72998 8.27053 14.1912 9.41135 19.9566C10.5522 25.7221 15.3788 29.6086 20.192 28.6373Z"
        fill="white"
      />
    </g>
    <path
      d="M20.3932 28.1704C25.2063 27.1992 28.1833 21.738 27.0425 15.9725C25.9017 10.2071 21.075 6.32057 16.2619 7.29182C11.4487 8.26306 8.4717 13.7242 9.61252 19.4897C10.7533 25.2552 15.58 29.1417 20.3932 28.1704Z"
      fill="#FEB724"
    />
    <path
      d="M26.6346 16.976C25.4939 11.211 20.6672 7.3241 15.854 8.29535C13.251 8.8206 11.1873 10.6598 10.0189 13.1488C11.0688 10.1574 13.3219 7.88686 16.2624 7.29348C21.0756 6.32223 25.9023 10.2091 27.0431 15.9742C27.567 18.6222 27.2202 21.2044 26.2286 23.3178C26.897 21.4138 27.0782 19.2178 26.6344 16.9752L26.6346 16.976Z"
      fill="#FB9D12"
    />
    <g filter="url(#filter0_i_330_6836)">
      <path
        d="M11.8987 17.1329C11.9693 17.4289 12.202 17.581 12.4938 17.51C12.7802 17.4403 12.9188 17.1978 12.8481 16.9018C12.7775 16.6058 12.5461 16.4591 12.2596 16.5289C11.9679 16.5999 11.828 16.8369 11.8987 17.1329ZM13.8051 21.123L13.0202 17.8343L12.1715 18.0408L12.9564 21.3296L13.8051 21.123Z"
        fill="#DB6402"
      />
      <path
        d="M16.0152 18.8394L16.4089 20.4893L17.2576 20.2827L16.8639 18.6328C16.6232 17.6243 15.9596 17.0782 15.1481 17.2758C14.8192 17.3558 14.5322 17.6112 14.4797 17.885L14.3881 17.5013L13.5394 17.7079L14.3243 20.9966L15.173 20.7901L14.7806 19.1457C14.6694 18.6798 14.8482 18.2767 15.2036 18.1902C15.5802 18.0985 15.9 18.3571 16.0152 18.8394Z"
        fill="#DB6402"
      />
      <path
        d="M18.6183 19.9515L18.2664 18.4771L19.658 19.6985L20.7348 19.4364L19.1489 18.0825L19.8385 16.1748L18.9102 16.4007L18.1853 18.1372L17.5064 15.2925L16.6577 15.499L17.7696 20.1581L18.6183 19.9515Z"
        fill="#DB6402"
      />
      <path
        d="M21.9012 19.1525L20.7892 14.4935L19.9406 14.7L21.0525 19.3591L21.9012 19.1525Z"
        fill="#DB6402"
      />
      <path
        d="M24.2408 17.516C24.1807 17.664 24.0054 17.7994 23.7561 17.8601C23.4272 17.9402 23.1163 17.7896 22.941 17.4785L25.1582 16.9389C25.1506 16.8364 25.1297 16.7254 25.1049 16.6213C24.8772 15.6676 24.0309 15.108 23.1398 15.3249C22.2487 15.5418 21.7477 16.4293 21.9753 17.383C22.2108 18.3696 23.0293 18.9069 23.9576 18.681C24.6047 18.5235 25.0716 17.9633 25.1425 17.2965L24.2408 17.516ZM22.7906 16.8482C22.8088 16.5016 23.0084 16.2326 23.3373 16.1526C23.6662 16.0725 23.9652 16.2201 24.1379 16.5203L22.7906 16.8482Z"
        fill="#DB6402"
      />
    </g>
    <defs>
      <filter
        id="filter0_i_330_6836"
        x="11.8809"
        y="14.4935"
        width="13.2773"
        height="7.79779"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="0.961697" />
        <feGaussianBlur stdDeviation="0.480849" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_330_6836"
        />
      </filter>
    </defs>
  </svg>
);
